import type { ReactNode } from 'react'
import { EVENT } from '@sdg/shared'
import { cn } from '../lib/cn'

/**
 * The application shell.
 *
 * Nothing sits above the content: the event name reads as a sign-off beneath
 * the card rather than a heading over it, so a phone screen opens straight
 * onto the task.
 */
export function AppShell({
  children,
  width = 'form',
}: {
  children: ReactNode
  /** form: registration, OTP, pass · wide: Judge and Admin tables */
  width?: 'form' | 'wide'
}) {
  return (
    <div className="flex min-h-dvh flex-col bg-deck">
      {/* Padding is symmetric so the auto margins below centre the column
          exactly; uneven padding left it sitting slightly high. */}
      <main className="safe-top flex flex-1 justify-center px-3.5 py-7 sm:px-6 sm:py-12">
        {/*
         * `my-auto` rather than `items-center`: it centres the column on a tall
         * screen but lets it grow past the container without clipping the top,
         * which matters on the pass page where the content is longer.
         */}
        <div
          className={cn(
            // Centred at every size, phones included.
            'my-auto w-full',
            width === 'form' ? 'max-w-115' : 'max-w-6xl',
          )}
        >
          {children}

          {/*
           * Two short lines, text only. A tall sign-off would push the
           * registration form past a phone screen, and the mark that sat here
           * collapsed into a smudge at 24px — it stays the favicon and PWA
           * icon, sizes at which it actually reads.
           */}
          <footer className="safe-bottom mt-3.5 text-center">
            <p className="text-[10px] leading-snug text-muted">
              <span className="text-[11px] font-bold text-navy-950">
                Lincoln International SDG &amp; Cultural Day 2026
              </span>
              <br />
              {/* The credit line carried on every slide of the deck. */}
              Technology Partner: <span className="font-bold">{EVENT.technologyPartner}</span>
              {' · '}
              <a
                href={EVENT.technologyPartnerUrl}
                target="_blank"
                rel="noreferrer noopener"
                className="text-teal hover:underline"
              >
                www.techvisionsoft.com
              </a>
            </p>
          </footer>
        </div>
      </main>
    </div>
  )
}
